module.exports = __webpack_public_path__ + "img/for-you07.6563083e.jpg";